import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {PlaylistVisibility} from '../userPlaylists/reducers';

export interface SettingsState {
    defaultPlaylistVisibility: PlaylistVisibility;
    reducedMotion: boolean;
    autoplayOnLaunch: boolean;
}

const initialState: SettingsState = {
    defaultPlaylistVisibility: 'private',
    reducedMotion: false,
    autoplayOnLaunch: false,
};

export const settingsSlice = createSlice({
    name: 'settings',
    initialState,
    reducers: {
        setDefaultPlaylistVisibility(state, action: PayloadAction<PlaylistVisibility>) {
            state.defaultPlaylistVisibility = action.payload;
        },
        setReducedMotion(state, action: PayloadAction<boolean>) {
            state.reducedMotion = action.payload;
        },
        setAutoplayOnLaunch(state, action: PayloadAction<boolean>) {
            state.autoplayOnLaunch = action.payload;
        },
    },
});

export const {
    setDefaultPlaylistVisibility,
    setReducedMotion,
    setAutoplayOnLaunch,
} = settingsSlice.actions;
export default settingsSlice.reducer;
